import { Component, Input, OnInit, SimpleChanges, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-modal-view-bareme-detail',
  templateUrl: './modal-view-bareme-detail.component.html',
  styleUrls: ['./modal-view-bareme-detail.component.scss']
})
export class ModalViewBaremeDetailComponent implements OnInit {
  itemToSave: any = {};
  itemBareme: any = {};
  filiale_id:any
  // bsModalRef: BsModalRef;
  user: any = {};
  currentData:any
  indiceTab =0
  title:string='barème'
  constructor(
    private authService: AuthService,
    public bsModalRef: BsModalRef,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
    private sanitizer: DomSanitizer
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser()
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id
    setTimeout(() => {
      console.log('this.currentData: ',this.currentData);
      
      if (this.currentData) {
        this.itemToSave = Object.assign({}, this.currentData);
      }
    }, 300);
  }
  selectedChangeValue(event : any)
  {
    console.log("le event selectedChangeValue",event);
    
    if(!event) this.indiceTab = 0;

    this.indiceTab = event;
  } 

  ngOnInit(): void {
  }

}
